import { Trans } from '@lingui/macro'

import {
  BaseHeaderContent,
  CompanyHero,
  CompanyImageCard,
  HeaderScreen,
} from '@segments/ScreenLayout'
import * as React from 'react'

import { StickyTopContent as SharedStickyContent } from '~shared/components/Sticky/StickyTopContent'
import { ProductCategoryNavigation, useProductListDataCtx } from '~shared/segments/ProductList'
import { Box, Grid } from '~ui/components/layout/Box'

import { useMenuScreenLayout } from '../hooks/useMenuScreenLayout'
import { PromoHeaderText } from './PromoHeaderText'

type TProps = RequiredChildren & {
  shouldRenderCategoryNav: boolean
  cart: React.ReactNode
}

/**
 * Container for the mobile menu screen.
 * Contains the company image and the promo header text.
 */
export const MobileMenuScreenContainer: React.FC<TProps> = ({
  cart,
  shouldRenderCategoryNav,
  children,
}) => {
  const { topCardsMarginBottom, stickyTopCardHeight, stickyTopCardPaddingTop } =
    useMenuScreenLayout()

  const categories = useProductListDataCtx()

  return (
    <HeaderScreen
      headerContent={
        <BaseHeaderContent //
          title={<Trans>Product list</Trans>}
          navigateTo={`home`}
        />
      }
    >
      <Grid gridTemplateRows={`auto 1fr`}>
        <CompanyImageCard padding={{ vertical: `large`, horizontal: `medium` }}>
          <CompanyHero logoSize={`5rem`} />
        </CompanyImageCard>
        <Box>
          <PromoHeaderText
            hasBorderBottom={!shouldRenderCategoryNav}
            bottomPadding={shouldRenderCategoryNav ? `none` : `smallMedium`}
          />

          {shouldRenderCategoryNav && (
            <SharedStickyContent
              isMobile
              bgColor={`bgColors.card`}
              bottomMargin={topCardsMarginBottom}
              topPadding={stickyTopCardPaddingTop}
              height={stickyTopCardHeight}
            >
              <Box padding={{ vertical: `none`, horizontal: `medium` }}>
                <ProductCategoryNavigation
                  isMobile
                  isTabletOrMobile
                  productCategories={categories}
                />
              </Box>
            </SharedStickyContent>
          )}
          <Box
            padding={{
              bottom: `none`,
              top: shouldRenderCategoryNav ? `none` : `mediumLarge`,
              left: `none`,
              right: `none`,
            }}
          >
            {children}
          </Box>
        </Box>
      </Grid>

      {cart}
    </HeaderScreen>
  )
}
